var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10173_5597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5018 17H0.498043C0.22299 17 0 16.777 0 16.5019C0 16.2269 0.22299 16.0039 0.498043 16.0039H16.5018C16.7769 16.0039 16.9999 16.2269 16.9999 16.5019C16.9999 16.777 16.7769 17 16.5018 17Z",
    fill: "#3B78CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51951 17H1.52734C1.25229 17 1.0293 16.777 1.0293 16.5019V12.8496C1.0293 12.3919 1.40167 12.0195 1.85937 12.0195H3.18748C3.64518 12.0195 4.01755 12.3919 4.01755 12.8496V16.5019C4.01755 16.777 3.79456 17 3.51951 17ZM2.02538 16.0039H3.02147V13.0156H2.02538V16.0039Z",
    fill: "#3B78CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50389 17H5.51171C5.23666 17 5.01367 16.777 5.01367 16.5019V11.6543C5.01367 11.1966 5.38604 10.8242 5.84374 10.8242H7.17186C7.62956 10.8242 8.00193 11.1966 8.00193 11.6543V16.5019C8.00193 16.777 7.77894 17 7.50389 17ZM6.00976 16.0039H7.00584V11.8203H6.00976V16.0039Z",
    fill: "#3B78CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4883 16.9999H9.49609C9.22104 16.9999 8.99805 16.7769 8.99805 16.5019V9.82812C8.99805 9.37042 9.37042 8.99805 9.82812 8.99805H11.1562C11.6139 8.99805 11.9863 9.37042 11.9863 9.82812V16.5019C11.9863 16.7769 11.7633 16.9999 11.4883 16.9999ZM9.99413 16.0039H10.9902V9.99413H9.99413V16.0039Z",
    fill: "#3B78CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4726 16.9999H13.4805C13.2054 16.9999 12.9824 16.7769 12.9824 16.5019V6.50781C12.9824 6.0501 13.3548 5.67773 13.8125 5.67773H15.1406C15.5983 5.67773 15.9707 6.0501 15.9707 6.50781V16.5019C15.9707 16.7769 15.7477 16.9999 15.4726 16.9999ZM13.9785 16.0038H14.9746V6.67382H13.9785V16.0038Z",
    fill: "#3B78CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.498043 10.7014C0.22299 10.7014 0 10.4784 0 10.2034C0 9.92834 0.22299 9.70535 0.498043 9.70535C3.42673 9.70535 6.61547 8.63888 9.47679 6.70238C12.1091 4.92088 14.2067 2.58539 15.2316 0.294762C15.344 0.0436817 15.6386 -0.0688096 15.8896 0.0435821C16.1407 0.155907 16.2532 0.450516 16.1408 0.701597C15.0423 3.15685 12.8168 5.64474 10.0351 7.52731C7.01068 9.57417 3.62366 10.7014 0.498043 10.7014Z",
    fill: "#3B78CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5016 4.04003C16.2817 4.04003 16.0805 3.89327 16.0209 3.67075L15.3342 1.10812L12.7716 1.79478C12.5058 1.86604 12.2328 1.70832 12.1616 1.44263C12.0904 1.17695 12.2481 0.903852 12.5138 0.832665L15.5575 0.0171032C15.8233 -0.054117 16.0963 0.103597 16.1675 0.369253L16.983 3.41296C17.0542 3.67865 16.8966 3.95174 16.6309 4.02293C16.5877 4.03448 16.5443 4.04003 16.5016 4.04003Z",
    fill: "#3B78CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10173_5597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.1e0048eaa19629ca77e8e7cbedd6dad0.svg";
export { ForwardRef as ReactComponent };